export default "__VITE_ASSET__54c7e612__"